import React, { useState, useEffect, useContext } from "react";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";

import DatePicker from "react-date-picker";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import { ERROR_MESSAGES } from "../GlobalMassage";
import SuccessPopupModal from "../SuccessPopupModal";
import { useAuth } from "../../../Context/AuthContext";
import {
  addUpdateBlog,
  AddUpdateUser,
  GetBlogModal,
  getUser,
} from "../../../Services/Admin User/AdminUser";

const AdminUserAddUpdateModal = ({
  show,
  onHide,
  setIsAddUpdateActionDone,
  modelRequestData,
}) => {
  const [modelAction, setModelAction] = useState("");
  const [error, setErrors] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const { setLoader, user } = useAuth();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setConfirmShowPassword] = useState(false);
  const [employeeObj, setEmployeeObj] = useState({
    firstName: null,
    lastName: null,
    phoneNumber: null,
    email: null,
    password: null,
    confirmPassword: null,
  });

  useEffect(() => {
    // debugger
    if (modelRequestData?.Action === "Update") {
      if (modelRequestData?.adminKeyID !== null) {
        GetBlogModalData(modelRequestData.adminKeyID);
      }
    }
  }, [modelRequestData?.Action]);

  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

  const AddCustomerBtnClick = async () => {
    // debugger
    let isValid = false;

    if (
      employeeObj.firstName === null ||
      employeeObj.firstName === undefined ||
      employeeObj.firstName === "" ||
      employeeObj.lastName === null ||
      employeeObj.lastName === undefined ||
      employeeObj.lastName === "" ||
      employeeObj.phoneNumber === null ||
      employeeObj.phoneNumber === undefined ||
      employeeObj.phoneNumber === "" ||
      employeeObj.phoneNumber?.length < 10 ||
      employeeObj.email === null ||
      employeeObj.email === undefined ||
      employeeObj.email === "" ||
      !emailRegex.test(employeeObj.email) ||
      employeeObj.password === null ||
      employeeObj.password === undefined ||
      employeeObj.password === "" ||
      employeeObj.confirmPassword === undefined ||
      employeeObj.confirmPassword === null ||
      employeeObj.confirmPassword === ""
    ) {
      setErrors(true);
      isValid = true;
    } else {
      setErrors(false);
      isValid = false;
    }

    const apiParam = {
      adminKeyID: modelRequestData.adminKeyID,
      firstName: employeeObj.firstName,
      lastName: employeeObj.lastName,
      email: employeeObj.email,
      phoneNumber: employeeObj.phoneNumber,
      password: employeeObj.password,
      confirmPassword: employeeObj.confirmPassword,
    };
    if (!isValid) {
      AddUpdateCustomerData(apiParam);
    }
  };

  const AddUpdateCustomerData = async (apiParam) => {
    // debugger
    setLoader(true);
    try {
      let url = "/AddUpdateUser"; // Default URL for Adding Data

      const response = await AddUpdateUser(url, apiParam);
      if (response) {
        if (response?.data?.statusCode === 200) {
          setLoader(false);
          // debugger
          setShowSuccessModal(true);
          setModelAction(
            modelRequestData.Action === null ||
              modelRequestData.Action === undefined
              ? "Admin Added Successfully!"
              : "Admin Updated Successfully!"
          ); //Do not change this naming convention

          setIsAddUpdateActionDone(true);
        } else {
          setLoader(false);
          setErrorMessage(response?.response?.data?.errorMessage);
        }
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  useEffect(() => {
    return () => {
      if (employeeObj?.featureImage?.startsWith("blob:")) {
        URL.revokeObjectURL(employeeObj.featureImage);
      }
    };
  }, [employeeObj?.featureImage]);

  const GetBlogModalData = async (id) => {
    setLoader(true);
    if (id === undefined) {
      return;
    }

    try {
      const data = await getUser(id);
      if (data?.data?.statusCode === 200) {
        setLoader(false);

        console.log(data, "dsadas324r");
        const ModelData = data.data.responseData.data[0]; // Assuming data is an array
        console.log(ModelData, "dsaiygd9s7a6ydsadsa");

        setEmployeeObj({
          ...employeeObj,

          adminKeyID: ModelData.adminKeyID,
          firstName: ModelData.firstName,
          lastName: ModelData.lastName,
          email: ModelData.email,
          phoneNumber: ModelData.phoneNumber,
          password: ModelData.password,
          confirmPassword: ModelData.password,
        });
      } else {
        setLoader(false);
        // Handle non-200 status codes if necessary
        console.error("Error fetching data: ", data?.data?.statusCode);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error in Customer : ", error);
    }
  };

  console.log(employeeObj.Title, "kdjsgauhydsa");

  const closeAllModal = () => {
    onHide();
    setShowSuccessModal(false);
  };

  return (
    <>
    {show && <div className="custom-backdrop" />}
      <Modal
        size="lg"
        show={show}
        style={{ zIndex: 1300 }}
        onHide={onHide}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <>
            <h4 className="text-center  project-main-mode text-dark">
              {modelRequestData?.Action !== null
                ? "Update Admin"
                : modelRequestData?.Action === null
                ? "Add Admin"
                : ""}
            </h4>
          </>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "55vh", overflow: "overlay" }}>
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-6 mb-2">
                <div>
                  <label htmlFor="firstName" className="form-label">
                    Enter First Name
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="firstName"
                    maxLength={250}
                    placeholder="Enter First Name"
                    aria-describedby="Employee"
                    value={employeeObj.firstName}
                    onChange={(e) => {
                      setErrorMessage(false);
                      let inputValue = e.target.value;
                      // If the input is empty or starts with a space, prevent the space
                      if (
                        inputValue.length === 0 ||
                        (inputValue.length === 1 && inputValue === " ")
                      ) {
                        inputValue = "";
                      }
                      // Remove unwanted characters (keeping spaces that aren't at the start)
                      const cleanedValue = inputValue.replace(
                        /[^a-zA-Z0-9\s]/g,
                        ""
                      );

                      // Trim leading spaces while keeping internal spaces
                      const trimmedValue = cleanedValue.trimStart();

                      // Capitalize the first letter and keep the rest as is
                      const updatedValue =
                        trimmedValue.charAt(0).toUpperCase() +
                        trimmedValue.slice(1);

                      setEmployeeObj((prev) => ({
                        ...prev,
                        firstName: updatedValue,
                      }));
                    }}
                  />

                  {error &&
                  (employeeObj.firstName === null ||
                    employeeObj.firstName === undefined ||
                    employeeObj.firstName === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="col-12 col-md-6 mb-2">
                <div>
                  <label htmlFor="clientName" className="form-label">
                    Enter Last Name
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="lastName"
                    maxLength={250}
                    placeholder="Enter First Name"
                    aria-describedby="Employee"
                    value={employeeObj.lastName}
                    onChange={(e) => {
                      setErrorMessage(false);
                      let inputValue = e.target.value;
                      // If the input is empty or starts with a space, prevent the space
                      if (
                        inputValue.length === 0 ||
                        (inputValue.length === 1 && inputValue === " ")
                      ) {
                        inputValue = "";
                      }
                      // Remove unwanted characters (keeping spaces that aren't at the start)
                      const cleanedValue = inputValue.replace(
                        /[^a-zA-Z0-9\s]/g,
                        ""
                      );

                      // Trim leading spaces while keeping internal spaces
                      const trimmedValue = cleanedValue.trimStart();

                      // Capitalize the first letter and keep the rest as is
                      const updatedValue =
                        trimmedValue.charAt(0).toUpperCase() +
                        trimmedValue.slice(1);

                      setEmployeeObj((prev) => ({
                        ...prev,
                        lastName: updatedValue,
                      }));
                    }}
                  />

                  {error &&
                  (employeeObj.lastName === null ||
                    employeeObj.lastName === undefined ||
                    employeeObj.lastName === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-6 mb-2">
                <div>
                  <label htmlFor="customerAddress" className="form-label">
                    Phone No.
                    <span style={{ color: "red" }}>*</span>
                  </label>

                  <input
                    className="form-control"
                    maxLength={10}
                    placeholder=" Phone Number"
                    value={employeeObj.phoneNumber}
                    onChange={(e) => {
                      setErrorMessage("");

                      const value = e.target.value;
                      let FormattedNumber = value.replace(/[^0-9]/g, ""); // Allows only numbers

                      // Apply regex to ensure the first digit is between 6 and 9
                      FormattedNumber = FormattedNumber.replace(/^[0-5]/, "");
                      setEmployeeObj((prev) => ({
                        ...prev,
                        phoneNumber: FormattedNumber,
                      }));
                    }}
                  />
                  <span style={{ color: "red" }}>
                    {error &&
                    (employeeObj.phoneNumber === null ||
                      employeeObj.phoneNumber === undefined ||
                      employeeObj.phoneNumber === "")
                      ? ERROR_MESSAGES
                      : (employeeObj.phoneNumber !== null ||
                          employeeObj.phoneNumber !== undefined) &&
                        employeeObj?.phoneNumber?.length < 10
                      ? "Invalid phone Number"
                      : ""}
                  </span>
                </div>
              </div>
              <div className="col-12 col-md-6 mb-2">
                <label className="form-label">Enter Email:</label>
                <input
                  type="text"
                  placeholder="Enter Email"
                  className="form-control "
                  maxLength={50}
                  value={employeeObj.email}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const trimmedValue = inputValue
                      .replace(/\s+/g, "")
                      .replace(/\.+/g, "."); // Remove consecutive dots
                    setEmployeeObj({
                      ...employeeObj,
                      email: trimmedValue,
                    });
                  }}
                  required
                />

                {error ? (
                  employeeObj.email === undefined ||
                  employeeObj.email === "" ? (
                    <label style={{ color: "red" }}>{ERROR_MESSAGES}</label>
                  ) : !emailRegex.test(employeeObj.email) ? (
                    <label className="validation" style={{ color: "red" }}>
                      Enter a valid email.
                    </label>
                  ) : null
                ) : null}
              </div>

              <div className="col-12 col-md-6 mb-2">
                <div>
                  <label htmlFor="password" className="form-label">
                    Password
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      maxLength={40}
                      className="form-control"
                      id="password"
                      placeholder="Enter Password"
                      value={employeeObj.password}
                      onChange={(e) => {
                        setErrorMessage(false);
                        const inputValue = e.target.value;
                        setEmployeeObj((prev) => ({
                          ...prev,
                          password: inputValue,
                        }));
                      }}
                      style={{ paddingRight: "40px" }} // Add padding so text doesn't overlap with the icon

                    />
                    <span
                      onClick={() => setShowPassword((prev) => !prev)}
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "12px",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        fontSize: "18px",
                        lineHeight: 1,
                      }}
                    >
                      {showPassword ? "🙈" : "👁️"}
                    </span>
                  </div>

                  {error &&
                  (employeeObj.password === null ||
                    employeeObj.password === undefined ||
                    employeeObj.password === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="col-12 col-md-6 mb-2">
                <div>
                  <label htmlFor="cnfPAss" className="form-label">
                    Enter Confirm Password
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      maxLength={40}
                      className="form-control"
                      id="cnfPAss"
                      placeholder="Enter Confirm Password"
                      value={employeeObj.confirmPassword}
                      onChange={(e) => {
                        setErrorMessage(false);
                        const inputValue = e.target.value;
                        setEmployeeObj((prev) => ({
                          ...prev,
                          confirmPassword: inputValue,
                        }));
                      }}
                    />
                    <span
                      onClick={() => setConfirmShowPassword((prev) => !prev)}
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "12px",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        fontSize: "18px",
                        lineHeight: 1,
                      }}
                    >
                      {showConfirmPassword ? "🙈" : "👁️"}
                    </span>
                  </div>

                  {error &&
                  (employeeObj.confirmPassword === null ||
                    employeeObj.confirmPassword === undefined ||
                    employeeObj.confirmPassword === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>

            {/* <div className="row"> */}
          </div>

          <span style={{ color: "red" }}>{errorMessage}</span>
          {/* </div> */}
        </Modal.Body>


        <Modal.Footer>
          <Button className="rts-btn border bg-transparent" onClick={onHide}>
            Close
          </Button>
          <Button
            type="submit"
          
            className=" rts-btn    text-center"
            onClick={() => AddCustomerBtnClick()}
          >
            Submit
          </Button>
        </Modal.Footer>
        
      </Modal>
      {showSuccessModal && (
        <SuccessPopupModal
          show={showSuccessModal}
          onHide={() => closeAllModal()}
          setShowSuccessModal={setShowSuccessModal}
          modelAction={modelAction}
        />
      )}
    </>
  );
};

export default AdminUserAddUpdateModal;
